/* Source: /tmp/jac-app-precompile-2740-qj0nt_zq/app/main.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { useEffect } from "@jac/runtime";
class GetIssues {
  constructor(props = {}) {}
  static __from_wire(d) {
    if (((d === null) || (d === undefined)))     return d;
    return new GetIssues(d);
  }
  __to_wire() {
    return {"__type__": "GetIssues"};
  }
}
class GetIssue {
  constructor(props = {}) {
    this.slug = (props.hasOwnProperty("slug") ? props.slug : "");
  }
  static __from_wire(d) {
    if (((d === null) || (d === undefined)))     return d;
    return new GetIssue(d);
  }
  __to_wire() {
    return {"__type__": "GetIssue", "slug": this.slug};
  }
}
class GetArticle {
  constructor(props = {}) {
    this.slug = (props.hasOwnProperty("slug") ? props.slug : "");
  }
  static __from_wire(d) {
    if (((d === null) || (d === undefined)))     return d;
    return new GetArticle(d);
  }
  __to_wire() {
    return {"__type__": "GetArticle", "slug": this.slug};
  }
}
class Subscribe {
  constructor(props = {}) {
    this.email = (props.hasOwnProperty("email") ? props.email : "");
  }
  static __from_wire(d) {
    if (((d === null) || (d === undefined)))     return d;
    return new Subscribe(d);
  }
  __to_wire() {
    return {"__type__": "Subscribe", "email": this.email};
  }
}
function App(props) {
  useEffect(() => {
    let icon;
    let head;
    document.title = "Jaseci Digest \u00b7 biweekly newsletter for the Jaseci & Jac ecosystem";
    let existing = document.querySelector("link[rel='icon']");
    if (!existing) {
      icon = document.createElement("link");
      icon.rel = "icon";
      icon.type = "image/png";
      icon.href = "/img/logo.png";
      head = document.head;
      head.appendChild(icon);
    }
  }, []);
  return __jacJsx(null, {}, [props.children]);
}
const app = App;
/*jac:refresh-boundary*/;
export {app};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"walker:GetIssues": {"is_writer": false, "touches": ["Root"]}, "walker:GetIssue": {"is_writer": false, "touches": ["Root"]}, "walker:GetArticle": {"is_writer": false, "touches": ["Root"]}, "walker:Subscribe": {"is_writer": false, "touches": ["Root"]}}); };
//# sourceMappingURL=main.js.map
